import instance from './instance'

const clientUrl = 'modules-lead/leads'
const clientLogUrl = 'modules-lead/client-logs'

export const getClientList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${clientUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getClientById = (id: number) => instance.get(`${clientUrl}/${id}`)

export const createClient = (payload: any) => instance.post(`${clientUrl}`, payload)

export const updateClient = (id: any, payload: any) => instance.post(`${clientUrl}/${id}`, payload)

export const deleteClient = async (id: number) => await instance.delete(`${clientUrl}/${id}`)

export const getClientLogById = (id: number) => instance.get(`${clientLogUrl}/${id}`)

export const updateKycStatus = (id: any, payload: any) =>
  instance.post(`modules-lead/update-kyc-status/${id}`, payload)

export const getKYCDocument = (id: number) => 
  instance.get(`modules-lead/view-kyc-document/${id}`)

export const updateKYCStatus = (id: number, payload: { status: string }) =>
  instance.post(`modules-lead/update-kyc-status/${id}`, payload)

export const exportTransactionCSV = () => 
  instance.get(`modules-lead/export-csv`)
